import { render, staticRenderFns } from "./Governance.vue?vue&type=template&id=db145816&scoped=true&"
import script from "./Governance.vue?vue&type=script&lang=js&"
export * from "./Governance.vue?vue&type=script&lang=js&"
import style0 from "./Governance.vue?vue&type=style&index=0&id=db145816&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db145816",
  null
  
)

export default component.exports